import { RouteObject } from 'react-router-dom';
import ForgetPassword from "../../Pages/OtherPages/Authentication/ForgetPassword/ForgetPassword";
import LoginSimple from "../../Pages/OtherPages/Authentication/LoginSimple/LoginSimple";
import LoginWithBackGroundImage from "../../Pages/OtherPages/Authentication/LoginWithBackGroundImage/LoginWithBackGroundImage";
import LoginWithImageTwo from "../../Pages/OtherPages/Authentication/LoginWithImageTwo/LoginWithImageTwo";
import LoginWithSweetAlert from "../../Pages/OtherPages/Authentication/LoginWithSweetAlert/LoginWithSweetAlert";
import LoginWithTooltip from "../../Pages/OtherPages/Authentication/LoginWithTooltip/LoginWithTooltip";
import LoginWithValidation from "../../Pages/OtherPages/Authentication/LoginWithValidation/LoginWithValidation";
import Maintenance from "../../Pages/OtherPages/Authentication/Maintenance/Maintenance";
import RegisterSimple from "../../Pages/OtherPages/Authentication/RegisterSimple/RegisterSimple";
import RegisterWithBgImage from "../../Pages/OtherPages/Authentication/RegisterWithBgImage/RegisterWithBgImage";
import RegisterWithImageTwo from "../../Pages/OtherPages/Authentication/RegisterWithImageTwo/RegisterWithImageTwo";
import RegisterWizard from "../../Pages/OtherPages/Authentication/RegisterWizard/RegisterWizard";
import ResetPassword from "../../Pages/OtherPages/Authentication/ResetPassword/ResetPassword";
import UnlockUser from "../../Pages/OtherPages/Authentication/UnlockUser/UnlockUser";
import ComingSoonSimple from "../../Pages/OtherPages/ComingSoon/ComingSoonSimple/ComingSoonSimple";
import ComingSoonWithBgImage from "../../Pages/OtherPages/ComingSoon/ComingSoonWithBgImage/ComingSoonWithBgImage";
import ComingWithBgVideo from "../../Pages/OtherPages/ComingSoon/ComingWithBgVideo/ComingWithBgVideo";
import Error400 from "../../Pages/OtherPages/Error/Error400/Error400";
import Error401 from "../../Pages/OtherPages/Error/Error401/Error401";
import Error403 from "../../Pages/OtherPages/Error/Error403/Error403";
import Error404 from "../../Pages/OtherPages/Error/Error404/Error404";
import Error500 from "../../Pages/OtherPages/Error/Error500/Error500";
import Error503 from "../../Pages/OtherPages/Error/Error503/Error503";
import Login from '../../Component/Authentication/Login';

export const authRoutes: RouteObject[] = [
  {
    path: `${process.env.PUBLIC_URL}/login`,
    element: <Login />,
  },
  //Error
  {
    path: `${process.env.PUBLIC_URL}/errors/error400`,
    element: <Error400 />,
  },
  {
    path: `${process.env.PUBLIC_URL}/errors/error401`,
    element: <Error401 />,
  },
  {
    path: `${process.env.PUBLIC_URL}/errors/error403`,
    element: <Error403 />,
  },
  {
    path: `${process.env.PUBLIC_URL}/errors/error404`,
    element: <Error404 />,
  },
  {
    path: `${process.env.PUBLIC_URL}/errors/error500`,
    element: <Error500 />,
  },
  {
    path: `${process.env.PUBLIC_URL}/errors/error503`,
    element: <Error503 />,
  },

  // Auth Pages
  {
    path: `${process.env.PUBLIC_URL}/authentication/loginsimple`,
    element: <LoginSimple />,
  },
  {
    path: `${process.env.PUBLIC_URL}/authentication/loginbgimage`,
    element: <LoginWithBackGroundImage />,
  },
  {
    path: `${process.env.PUBLIC_URL}/authentication/loginwithimagetwo`,
    element: <LoginWithImageTwo />,
  },
  {
    path: `${process.env.PUBLIC_URL}/authentication/loginvalidation`,
    element: <LoginWithValidation />,
  },
  {
    path: `${process.env.PUBLIC_URL}/authentication/logintooltip`,
    element: <LoginWithTooltip />,
  },
  {
    path: `${process.env.PUBLIC_URL}/authentication/loginsweetalert`,
    element: <LoginWithSweetAlert />,
  },
  {
    path: `${process.env.PUBLIC_URL}/authentication/registersimple`,
    element: <RegisterSimple />,
  },
  {
    path: `${process.env.PUBLIC_URL}/authentication/registerbgimage`,
    element: <RegisterWithBgImage />,
  },
  {
    path: `${process.env.PUBLIC_URL}/authentication/registerwithimagetwo`,
    element: <RegisterWithImageTwo />,
  },
  {
    path: `${process.env.PUBLIC_URL}/authentication/registerwizard`,
    element: <RegisterWizard />,
  },
  {
    path: `${process.env.PUBLIC_URL}/authentication/unlockuser`,
    element: <UnlockUser />,
  },
  {
    path: `${process.env.PUBLIC_URL}/authentication/forgetpassword`,
    element: <ForgetPassword />,
  },
  {
    path: `${process.env.PUBLIC_URL}/authentication/resetpassword`,
    element: <ResetPassword />,
  },
  {
    path: `${process.env.PUBLIC_URL}/authentication/maintenance`,
    element: <Maintenance />,
  },

  //  ComingSoon
  {
    path: `${process.env.PUBLIC_URL}/comingsoon/comingsoonsimple`,
    element: <ComingSoonSimple />,
  },
  {
    path: `${process.env.PUBLIC_URL}/comingsoon/comingbgvideo`,
    element: <ComingWithBgVideo />,
  },
  {
    path: `${process.env.PUBLIC_URL}/comingsoon/comingbgimg`,
    element: <ComingSoonWithBgImage />,
  },
];
